import {
  FieldTypes,
  hiddenFormField,
  ImageUrlFields,
  AllSelectOptionFields,
} from 'drapcode-constant';
import { OTPFields, SubTenantFields, TenantFields, UserSettingsFields } from '../fields/FieldTypes';
export const extApis = [
  'REST_API',
  'AIRTABLE',
  'XANO',
  'NOTION',
  'APP_WRITE',
  'SUPABASE',
  'XATA',
  'DIRECTUS',
];
export const pageDirections = [
  { value: 'ltr', label: 'Left to Right (Default)' },
  { value: 'rtl', label: 'Right to Left' },
];

export const bindOptions = [
  { value: '', label: 'Select Bind Data From' },
  { value: 'COLLECTION', label: 'Collection (Default)' },
  { value: 'EXTERNAL_API', label: 'External API' },
];
export const filterFieldsForTitleAndDescription = (fields) => {
  return fields.filter((field) => {
    return (
      !hiddenFormField.includes(field.type) &&
      !ImageUrlFields.includes(field.type) &&
      !AllSelectOptionFields.includes(field.type) &&
      !TenantFields.includes(field.fieldName) &&
      !UserSettingsFields.includes(field.fieldName) &&
      !SubTenantFields.includes(field.fieldName) &&
      !OTPFields.includes(field.fieldName) &&
      field.type !== FieldTypes.large_text.id &&
      field.type !== FieldTypes.password.id
    );
  });
};

export const filterFieldsForImage = (fields) => {
  return fields.filter(
    (field) =>
      field.type === FieldTypes.file.id &&
      field.validation &&
      field.validation.noAllowedFiles === 1,
  );
};

export const pageCopyOptions = (value) => {
  let options = [
    { value: '', label: '- Select One -' },
    { value: 'fromExistingPages', label: `${value} from Existing Pages` },
    { value: 'fromPageSnapshots', label: `${value} from Page Snapshots` },
  ];

  return options;
};

export const snippetCopyOptions = (value) => {
  let options = [
    { value: '', label: '- Select One -' },
    { value: 'fromExistingSnippets', label: `${value} from Existing Snippets` },
    { value: 'fromSnippetSnapshots', label: `${value} from Snippet Snapshots` },
  ];
  return options;
};
